import React, { RefObject } from 'react';
import { ReadStats } from 'new/elements/ReadStats/ReadStats';
import { useResourceMeta } from 'new/hooks/adapters/useResourceMeta';
import {
  CONNECTION_CATEGORY_FILE,
  TIME_BASED_METRICS_FILE_CONNECTORS,
  CONNECTION_CATEGORY_TEMPLATIZED_EMAIL_SCRIPT,
} from 'js/constants/connectionCategories';
import { RESOURCE_TYPE_SOURCE } from 'js/constants/resourceTypes';
import { FILE_LIST_MODE_TYPES } from 'js/constants/paginationConstants';

interface ResourceReadStatsProps {
  data?: any;
  resourceType: string;
  parentScrollRef?: RefObject<any>;
}

export const ResourceReadStats = (props: ResourceReadStatsProps) => {
  const { data, resourceType, parentScrollRef } = props;
  const isAdaptiveFlow = data?.['adaptive_flow'] === true && resourceType === RESOURCE_TYPE_SOURCE;

  const meta = useResourceMeta(resourceType, data?.id, data?.data_credentials);

  const useFiles =
    isAdaptiveFlow ||
    ([CONNECTION_CATEGORY_FILE, CONNECTION_CATEGORY_TEMPLATIZED_EMAIL_SCRIPT].includes(
      meta?.connectionCategory,
    ) &&
      !TIME_BASED_METRICS_FILE_CONNECTORS.includes(meta?.key));

  return (
    <ReadStats
      mode={
        resourceType === RESOURCE_TYPE_SOURCE
          ? (FILE_LIST_MODE_TYPES.MODE_READ as 'MODE_READ')
          : (FILE_LIST_MODE_TYPES.MODE_WRITE as 'MODE_WRITE')
      }
      parentScrollRef={parentScrollRef}
      requestOnMount
      resourceId={data.id}
      connectionCategory={meta?.connectionCategory}
      useFiles={useFiles}
      resourceType={resourceType}
      isAdaptiveFlow={isAdaptiveFlow}
      data={data}
    />
  );
};
